import {appUrl} from '@frontend/AppUrl'
import type {ExecutorDetailsTabName} from '@frontend/modules/public/services/ServicesModuleTypes'
import {NavigationService} from 'swayok-react-mdb-ui-kit/services/NavigationService'

// Создание ссылки на профиль исполнителя услуг.
// Позже, вероятно, добавится аргумент slug для SEO.
export function makeExecutorUrl(
    // Можно указать {slug}-{id} или ID исполнителя.
    executorSlugWithId: string,
    // Заглушку 'details' можно использовать только в кабинете пользователя!
    // В этом случае backend сделает redirect на правильный URL.
    categorySlugWithId: Exclude<string, ExecutorDetailsTabName> | 'details',
    tab?: ExecutorDetailsTabName
): string {
    return NavigationService.makeUrl(
        appUrl().services.details,
        {
            slugWithId: executorSlugWithId,
            categorySlugWithId,
        },
        tab ? {tab} : null
    )
}
